import {
  faCheckCircle,
  faFolderOpen,
  faLockOpen,
  faPaperPlane,
  faSearch,
  faSeedling,
  faWarning,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'

/**
 * Nomes de EXIBIÇÃO de todos os status que a API pode devolver.
 * Separado de `dados_status` de propósito: os cods 6, 7 e 8 chegam do backend e
 * precisam renderizar na tag, mas não são status que o usuário possa escolher
 * manualmente (quem os atribui é o processamento do resultado).
 */
export const statusNomes: Record<number, string> = {
  1: 'ABERTA',
  2: 'LIBERADA',
  3: 'COLETADA',
  4: 'ENVIADO PARA ANÁLISE',
  5: 'EM ANÁLISE',
  6: 'INCONSISTÊNCIA MODERADA',
  7: 'INCONSISTÊNCIA ALTA',
  8: 'RESULTADO COM ERRO',
  9: 'ANALISADA',
}

/** cod do status COLETADA — a OS já teve a coleta realizada em campo. */
export const STATUS_COLETADA = 3

/** Opções SELECIONÁVEIS na linha do tempo (não é dicionário de nomes). */
export const dados_status = [
  {
    nome: statusNomes[1],
    cod: 1,
    disable: false,
  },
  {
    nome: statusNomes[2],
    cod: 2,
    disable: false,
    hidden: process.env.NODE_ENV === 'production',
  },
  {
    nome: statusNomes[3],
    cod: 3,
    disable: false,
  },
  {
    nome: statusNomes[4],
    cod: 4,
    disable: false,
  },
  {
    nome: statusNomes[5],
    cod: 5,
    disable: false,
  },
  {
    nome: statusNomes[6],
    cod: 6,
    disable: false,
    hidden: process.env.NODE_ENV === 'production',
  },
  {
    nome: statusNomes[7],
    cod: 7,
    disable: false,
    hidden: process.env.NODE_ENV === 'production',
  },
  {
    nome: statusNomes[8],
    cod: 8,
    disable: false,
    hidden: process.env.NODE_ENV === 'production',
  },
  {
    nome: statusNomes[9],
    cod: 9,
    disable: false,
    // hidden: process.env.NODE_ENV === "production",
  },
]

export const statusIcones = {
  1: faFolderOpen,
  2: faLockOpen,
  3: faSeedling,
  4: faPaperPlane,
  5: faSearch,
  6: faWarning,
  7: faWarning,
  8: faXmark,
  9: faCheckCircle,
}

export const statusBackground = {
  1: '#E6FFFB',
  2: '#FFF7E6',
  3: '#F0F5FF',
  4: '#F9F0FF',
  5: '#E6F4FF',
  6: '#FFF7E6',
  7: '#FFFEED',
  8: '#FDEFEF',
  9: '#F6FFED',
}

export const statusBorder = {
  1: '#87E8DE',
  2: '#D46B08',
  3: '#ADC6FF',
  4: '#D3ADF7',
  5: '#91CAFF',
  6: '#FFD591',
  7: '#EFC82D',
  8: '#FF4D4F',
  9: '#76C515',
}

export const statusColor = {
  1: '#08979C',
  2: '#D46B08',
  3: '#1D39C4',
  4: '#531DAB',
  5: '#1677FF',
  6: '#FA8C16',
  7: '#F8CE26',
  8: '#FF4D4F',
  9: '#76C515',
}
